import { render, staticRenderFns } from "./m-list-top.vue?vue&type=template&id=5d152515&scoped=true"
import script from "./m-list-top.vue?vue&type=script&lang=js"
export * from "./m-list-top.vue?vue&type=script&lang=js"
import style0 from "./m-list-top.vue?vue&type=style&index=0&id=5d152515&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d152515",
  null
  
)

export default component.exports